/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BillOfOperationsUsageDto,
  CheckImageDto,
  CheckImageUploadBodyDto,
  OperationBulkUpdateDto,
  OperationCategoryDto,
  OperationChecksDraftDto,
  OperationChecksDraftUpdateDto,
  OperationCommitResultDto,
  OperationCreateInputDto,
  OperationDetailDto,
  OperationDetailsDraftDto,
  OperationDetailsDraftUpdateDto,
  OperationListItemDto,
  OperationReleaseTargetDto,
  OperationReorderInputDto,
  OperationStationDto,
  OperationStationToggleDto,
  OperationStationToggleResultDto,
  OperationStationsDraftCommitResultDto,
  OperationStationsDraftDto,
  OperationStationsDraftUpdateDto,
  OperationSubCategoryDto,
  OperationUpdateDto,
  OperationsChecksMatrixItemDto,
  OperationsControllerCreateOperation201,
  OperationsControllerGetChecksMatrixParams,
  OperationsControllerListOperationSubCategoriesParams,
  OperationsControllerListOperationsParams,
  OperationsControllerUploadCheckImageParams,
  RelevanceRuleDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type operationsControllerListOperationCategoriesResponse200 = {
  data: OperationCategoryDto[]
  status: 200
}

export type operationsControllerListOperationCategoriesResponseSuccess = (operationsControllerListOperationCategoriesResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationCategoriesResponse = (operationsControllerListOperationCategoriesResponseSuccess)

export const getOperationsControllerListOperationCategoriesUrl = () => {




  return `/operations/categories`
}

/**
 * Returns the global list of operation categories used to populate the create-operation form. Categories are not partner-scoped — a single global enum-like table.
 * @summary List operation categories
 */
export const operationsControllerListOperationCategories = async ( options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListOperationCategoriesResponse> => {

  return customFetch<operationsControllerListOperationCategoriesResponse>(getOperationsControllerListOperationCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListOperationCategoriesQueryKey = () => {
    return [
    `/operations/categories`
    ] as const;
    }


export const getOperationsControllerListOperationCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>> = ({ signal }) => operationsControllerListOperationCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>>
export type OperationsControllerListOperationCategoriesQueryError = unknown


export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operation categories
 */

export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List operation categories
 */
export const prefetchOperationsControllerListOperationCategoriesQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationCategoriesQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListOperationCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>> = ({ signal }) => operationsControllerListOperationCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>>
export type OperationsControllerListOperationCategoriesSuspenseQueryError = unknown


export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operation categories
 */

export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerListOperationSubCategoriesResponse200 = {
  data: OperationSubCategoryDto[]
  status: 200
}

export type operationsControllerListOperationSubCategoriesResponseSuccess = (operationsControllerListOperationSubCategoriesResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationSubCategoriesResponse = (operationsControllerListOperationSubCategoriesResponseSuccess)

export const getOperationsControllerListOperationSubCategoriesUrl = (params?: OperationsControllerListOperationSubCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations/sub-categories?${stringifiedParams}` : `/operations/sub-categories`
}

/**
 * Returns the global list of operation sub-categories. When `operation_category` is provided, filters to sub-categories belonging to that category. Used by the operation form's cascading sub-category dropdown.
 * @summary List operation sub-categories
 */
export const operationsControllerListOperationSubCategories = async (params?: OperationsControllerListOperationSubCategoriesParams, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListOperationSubCategoriesResponse> => {

  return customFetch<operationsControllerListOperationSubCategoriesResponse>(getOperationsControllerListOperationSubCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListOperationSubCategoriesQueryKey = (params?: OperationsControllerListOperationSubCategoriesParams,) => {
    return [
    `/operations/sub-categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperationsControllerListOperationSubCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationSubCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>> = ({ signal }) => operationsControllerListOperationSubCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationSubCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>>
export type OperationsControllerListOperationSubCategoriesQueryError = unknown


export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params: undefined |  OperationsControllerListOperationSubCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operation sub-categories
 */

export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationSubCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List operation sub-categories
 */
export const prefetchOperationsControllerListOperationSubCategoriesQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 queryClient: QueryClient, params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationSubCategoriesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListOperationSubCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationSubCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>> = ({ signal }) => operationsControllerListOperationSubCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationSubCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>>
export type OperationsControllerListOperationSubCategoriesSuspenseQueryError = unknown


export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params: undefined |  OperationsControllerListOperationSubCategoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operation sub-categories
 */

export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationSubCategoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerListOperationsResponse200 = {
  data: OperationListItemDto[]
  status: 200
}

export type operationsControllerListOperationsResponseSuccess = (operationsControllerListOperationsResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationsResponse = (operationsControllerListOperationsResponseSuccess)

export const getOperationsControllerListOperationsUrl = (params: OperationsControllerListOperationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations?${stringifiedParams}` : `/operations`
}

/**
 * Returns the current version of every operation owned by the partner. Optionally filtered by name, location, Product Type, and archived state. Location filters match where the operation is enabled. Product Type matches current released Run Sheets. Each row includes the unfiltered count of non-archived current Run Sheets containing the operation.
 * @summary List operations for a partner
 */
export const operationsControllerListOperations = async (params: OperationsControllerListOperationsParams, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListOperationsResponse> => {

  return customFetch<operationsControllerListOperationsResponse>(getOperationsControllerListOperationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListOperationsQueryKey = (params?: OperationsControllerListOperationsParams,) => {
    return [
    `/operations`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperationsControllerListOperationsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperations>>> = ({ signal }) => operationsControllerListOperations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperations>>>
export type OperationsControllerListOperationsQueryError = unknown


export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operations for a partner
 */

export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List operations for a partner
 */
export const prefetchOperationsControllerListOperationsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 queryClient: QueryClient, params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListOperationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperations>>> = ({ signal }) => operationsControllerListOperations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperations>>>
export type OperationsControllerListOperationsSuspenseQueryError = unknown


export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List operations for a partner
 */

export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerCreateOperationResponse201 = {
  data: OperationsControllerCreateOperation201
  status: 201
}

export type operationsControllerCreateOperationResponse400 = {
  data: void
  status: 400
}

export type operationsControllerCreateOperationResponseSuccess = (operationsControllerCreateOperationResponse201) & {
  headers: Headers;
};
export type operationsControllerCreateOperationResponseError = (operationsControllerCreateOperationResponse400) & {
  headers: Headers;
};

export type operationsControllerCreateOperationResponse = (operationsControllerCreateOperationResponseSuccess | operationsControllerCreateOperationResponseError)

export const getOperationsControllerCreateOperationUrl = () => {




  return `/operations`
}

/**
 * Inserts both an operations row and a v1 operation_versions row in a single transaction. The new operation is immediately editable from /operations/:operation_id and can be added to a Run Sheet via the matrix.
 * @summary Create a new operation
 */
export const operationsControllerCreateOperation = async (operationCreateInputDto: OperationCreateInputDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerCreateOperationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerCreateOperationResponse>(getOperationsControllerCreateOperationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationCreateInputDto)
  }
);}





export const getOperationsControllerCreateOperationMutationKey = () => ['operationsControllerCreateOperation'] as const;

export const getOperationsControllerCreateOperationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,OperationsControllerCreateOperationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,OperationsControllerCreateOperationMutationVariables, TContext> => {

const mutationKey = getOperationsControllerCreateOperationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, OperationsControllerCreateOperationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerCreateOperation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerCreateOperationMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerCreateOperation>>>
    export type OperationsControllerCreateOperationMutationBody = OperationCreateInputDto
    export type OperationsControllerCreateOperationMutationError = void
    export type OperationsControllerCreateOperationMutationVariables = {data: OperationCreateInputDto}

    /**
 * @summary Create a new operation
 */
export const useOperationsControllerCreateOperation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,OperationsControllerCreateOperationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerCreateOperation>>,
        TError,
        OperationsControllerCreateOperationMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerCreateOperationMutationOptions(options), queryClient);
    }
    export type operationsControllerGetChecksMatrixResponse200 = {
  data: OperationsChecksMatrixItemDto[]
  status: 200
}

export type operationsControllerGetChecksMatrixResponse401 = {
  data: void
  status: 401
}

export type operationsControllerGetChecksMatrixResponse403 = {
  data: void
  status: 403
}

export type operationsControllerGetChecksMatrixResponseSuccess = (operationsControllerGetChecksMatrixResponse200) & {
  headers: Headers;
};
export type operationsControllerGetChecksMatrixResponseError = (operationsControllerGetChecksMatrixResponse401 | operationsControllerGetChecksMatrixResponse403) & {
  headers: Headers;
};

export type operationsControllerGetChecksMatrixResponse = (operationsControllerGetChecksMatrixResponseSuccess | operationsControllerGetChecksMatrixResponseError)

export const getOperationsControllerGetChecksMatrixUrl = (params: OperationsControllerGetChecksMatrixParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations/checks-matrix?${stringifiedParams}` : `/operations/checks-matrix`
}

/**
 * @summary Read checks and drafts for all active operations in a partner
 */
export const operationsControllerGetChecksMatrix = async (params: OperationsControllerGetChecksMatrixParams, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerGetChecksMatrixResponse> => {

  return customFetch<operationsControllerGetChecksMatrixResponse>(getOperationsControllerGetChecksMatrixUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerGetChecksMatrixQueryKey = (params?: OperationsControllerGetChecksMatrixParams,) => {
    return [
    `/operations/checks-matrix`, ...(params ? [params] : [])
    ] as const;
    }


export const getOperationsControllerGetChecksMatrixQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetChecksMatrixQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>> = ({ signal }) => operationsControllerGetChecksMatrix(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetChecksMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>>
export type OperationsControllerGetChecksMatrixQueryError = void


export function useOperationsControllerGetChecksMatrix<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetChecksMatrix<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetChecksMatrix<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read checks and drafts for all active operations in a partner
 */

export function useOperationsControllerGetChecksMatrix<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetChecksMatrixQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Read checks and drafts for all active operations in a partner
 */
export const prefetchOperationsControllerGetChecksMatrixQuery = async <TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 queryClient: QueryClient, params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerGetChecksMatrixQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerGetChecksMatrixSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetChecksMatrixQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>> = ({ signal }) => operationsControllerGetChecksMatrix(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetChecksMatrixSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>>
export type OperationsControllerGetChecksMatrixSuspenseQueryError = void


export function useOperationsControllerGetChecksMatrixSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetChecksMatrixSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetChecksMatrixSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read checks and drafts for all active operations in a partner
 */

export function useOperationsControllerGetChecksMatrixSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError = void>(
 params: OperationsControllerGetChecksMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetChecksMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetChecksMatrixSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerReorderOperationsResponse204 = {
  data: void
  status: 204
}

export type operationsControllerReorderOperationsResponse400 = {
  data: void
  status: 400
}

export type operationsControllerReorderOperationsResponse403 = {
  data: void
  status: 403
}

export type operationsControllerReorderOperationsResponseSuccess = (operationsControllerReorderOperationsResponse204) & {
  headers: Headers;
};
export type operationsControllerReorderOperationsResponseError = (operationsControllerReorderOperationsResponse400 | operationsControllerReorderOperationsResponse403) & {
  headers: Headers;
};

export type operationsControllerReorderOperationsResponse = (operationsControllerReorderOperationsResponseSuccess | operationsControllerReorderOperationsResponseError)

export const getOperationsControllerReorderOperationsUrl = () => {




  return `/operations/sequence`
}

/**
 * Reassigns operation_sequence across the partner's operations to match the supplied order. Index 0 maps to operation_sequence 1. The full ordered array of operation_ids must be supplied; the server overwrites all sequence values atomically. Run Sheet views continue to order by each Run Sheet's operation_order on the junction; only newly released Run Sheets pick up the partner-level sequence as their default.
 * @summary Reorder operations for a partner (admin only)
 */
export const operationsControllerReorderOperations = async (operationReorderInputDto: OperationReorderInputDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerReorderOperationsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerReorderOperationsResponse>(getOperationsControllerReorderOperationsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationReorderInputDto)
  }
);}





export const getOperationsControllerReorderOperationsMutationKey = () => ['operationsControllerReorderOperations'] as const;

export const getOperationsControllerReorderOperationsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,OperationsControllerReorderOperationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,OperationsControllerReorderOperationsMutationVariables, TContext> => {

const mutationKey = getOperationsControllerReorderOperationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, OperationsControllerReorderOperationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerReorderOperations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerReorderOperationsMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerReorderOperations>>>
    export type OperationsControllerReorderOperationsMutationBody = OperationReorderInputDto
    export type OperationsControllerReorderOperationsMutationError = void
    export type OperationsControllerReorderOperationsMutationVariables = {data: OperationReorderInputDto}

    /**
 * @summary Reorder operations for a partner (admin only)
 */
export const useOperationsControllerReorderOperations = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,OperationsControllerReorderOperationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerReorderOperations>>,
        TError,
        OperationsControllerReorderOperationsMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerReorderOperationsMutationOptions(options), queryClient);
    }
    export type operationsControllerUploadCheckImageResponse201 = {
  data: CheckImageDto
  status: 201
}

export type operationsControllerUploadCheckImageResponse400 = {
  data: void
  status: 400
}

export type operationsControllerUploadCheckImageResponse401 = {
  data: void
  status: 401
}

export type operationsControllerUploadCheckImageResponse403 = {
  data: void
  status: 403
}

export type operationsControllerUploadCheckImageResponseSuccess = (operationsControllerUploadCheckImageResponse201) & {
  headers: Headers;
};
export type operationsControllerUploadCheckImageResponseError = (operationsControllerUploadCheckImageResponse400 | operationsControllerUploadCheckImageResponse401 | operationsControllerUploadCheckImageResponse403) & {
  headers: Headers;
};

export type operationsControllerUploadCheckImageResponse = (operationsControllerUploadCheckImageResponseSuccess | operationsControllerUploadCheckImageResponseError)

export const getOperationsControllerUploadCheckImageUrl = (params: OperationsControllerUploadCheckImageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations/check-images?${stringifiedParams}` : `/operations/check-images`
}

/**
 * Accepts a single image (jpeg/png/gif/webp, ≤10 MB) and stores it in Google Cloud Storage under operations/checks_images/, inserting a matching public.images row. Returns an Image-shaped object the frontend embeds verbatim into an operation check via PATCH /operations/:operation_id. The stored image is served through GET /quality/evidence/file/:partner_name/{path} (GCS-first, Supabase legacy fallback) — no new serving code is required. partner_id is supplied in the query string because the multipart body is not parsed until after the guards run.
 * @summary Upload an image for an operation check
 */
export const operationsControllerUploadCheckImage = async (checkImageUploadBodyDto: CheckImageUploadBodyDto,
    params: OperationsControllerUploadCheckImageParams, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerUploadCheckImageResponse> => {
    const formData = new FormData();
if(checkImageUploadBodyDto.title !== undefined) {
 formData.append(`title`, checkImageUploadBodyDto.title);
 }
if(checkImageUploadBodyDto.tags !== undefined) {
 checkImageUploadBodyDto.tags.forEach(value => formData.append(`tags`, value));
 }

  return customFetch<operationsControllerUploadCheckImageResponse>(getOperationsControllerUploadCheckImageUrl(params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getOperationsControllerUploadCheckImageMutationKey = () => ['operationsControllerUploadCheckImage'] as const;

export const getOperationsControllerUploadCheckImageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,OperationsControllerUploadCheckImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,OperationsControllerUploadCheckImageMutationVariables, TContext> => {

const mutationKey = getOperationsControllerUploadCheckImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, OperationsControllerUploadCheckImageMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  operationsControllerUploadCheckImage(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerUploadCheckImageMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>>
    export type OperationsControllerUploadCheckImageMutationBody = CheckImageUploadBodyDto
    export type OperationsControllerUploadCheckImageMutationError = void
    export type OperationsControllerUploadCheckImageMutationVariables = {data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams}

    /**
 * @summary Upload an image for an operation check
 */
export const useOperationsControllerUploadCheckImage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,OperationsControllerUploadCheckImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>,
        TError,
        OperationsControllerUploadCheckImageMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerUploadCheckImageMutationOptions(options), queryClient);
    }
    export type operationsControllerGetOperationDetailResponse200 = {
  data: OperationDetailDto
  status: 200
}

export type operationsControllerGetOperationDetailResponse404 = {
  data: void
  status: 404
}

export type operationsControllerGetOperationDetailResponseSuccess = (operationsControllerGetOperationDetailResponse200) & {
  headers: Headers;
};
export type operationsControllerGetOperationDetailResponseError = (operationsControllerGetOperationDetailResponse404) & {
  headers: Headers;
};

export type operationsControllerGetOperationDetailResponse = (operationsControllerGetOperationDetailResponseSuccess | operationsControllerGetOperationDetailResponseError)

export const getOperationsControllerGetOperationDetailUrl = (operationId: string,) => {




  return `/operations/${operationId}`
}

/**
 * Returns the operation row plus its current operation_versions row (work_time, headcount, category, pre-flight + in-process checks). Used by the Quality operation detail page.
 * @summary Get the current version of an operation
 */
export const operationsControllerGetOperationDetail = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerGetOperationDetailResponse> => {

  return customFetch<operationsControllerGetOperationDetailResponse>(getOperationsControllerGetOperationDetailUrl(operationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerGetOperationDetailQueryKey = (operationId: string,) => {
    return [
    `/operations/${operationId}`
    ] as const;
    }


export const getOperationsControllerGetOperationDetailQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationDetailQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>> = ({ signal }) => operationsControllerGetOperationDetail(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetOperationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>>
export type OperationsControllerGetOperationDetailQueryError = void


export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current version of an operation
 */

export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetOperationDetailQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get the current version of an operation
 */
export const prefetchOperationsControllerGetOperationDetailQuery = async <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerGetOperationDetailQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerGetOperationDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationDetailQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>> = ({ signal }) => operationsControllerGetOperationDetail(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetOperationDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>>
export type OperationsControllerGetOperationDetailSuspenseQueryError = void


export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current version of an operation
 */

export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetOperationDetailSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerUpdateOperationResponse200 = {
  data: OperationCommitResultDto
  status: 200
}

export type operationsControllerUpdateOperationResponse409 = {
  data: void
  status: 409
}

export type operationsControllerUpdateOperationResponseSuccess = (operationsControllerUpdateOperationResponse200) & {
  headers: Headers;
};
export type operationsControllerUpdateOperationResponseError = (operationsControllerUpdateOperationResponse409) & {
  headers: Headers;
};

export type operationsControllerUpdateOperationResponse = (operationsControllerUpdateOperationResponseSuccess | operationsControllerUpdateOperationResponseError)

export const getOperationsControllerUpdateOperationUrl = (operationId: string,) => {




  return `/operations/${operationId}`
}

/**
 * @summary Commit operation changes and pending check availability cleanup
 */
export const operationsControllerUpdateOperation = async (operationId: string,
    operationUpdateDto: OperationUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerUpdateOperationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerUpdateOperationResponse>(getOperationsControllerUpdateOperationUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationUpdateDto)
  }
);}





export const getOperationsControllerUpdateOperationMutationKey = () => ['operationsControllerUpdateOperation'] as const;

export const getOperationsControllerUpdateOperationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,OperationsControllerUpdateOperationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,OperationsControllerUpdateOperationMutationVariables, TContext> => {

const mutationKey = getOperationsControllerUpdateOperationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, OperationsControllerUpdateOperationMutationVariables> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerUpdateOperation(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerUpdateOperationMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>>
    export type OperationsControllerUpdateOperationMutationBody = OperationUpdateDto
    export type OperationsControllerUpdateOperationMutationError = void
    export type OperationsControllerUpdateOperationMutationVariables = {operationId: string;data: OperationUpdateDto}

    /**
 * @summary Commit operation changes and pending check availability cleanup
 */
export const useOperationsControllerUpdateOperation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,OperationsControllerUpdateOperationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerUpdateOperation>>,
        TError,
        OperationsControllerUpdateOperationMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerUpdateOperationMutationOptions(options), queryClient);
    }
    export type operationsControllerListBillsOfOperationsForOperationResponse200 = {
  data: BillOfOperationsUsageDto[]
  status: 200
}

export type operationsControllerListBillsOfOperationsForOperationResponseSuccess = (operationsControllerListBillsOfOperationsForOperationResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListBillsOfOperationsForOperationResponse = (operationsControllerListBillsOfOperationsForOperationResponseSuccess)

export const getOperationsControllerListBillsOfOperationsForOperationUrl = (operationId: string,) => {




  return `/operations/${operationId}/bills-of-operations`
}

/**
 * Returns each Run Sheet whose current version includes this operation, with a work-orders-behind count so the operation detail page can surface where releases are needed. Each row also resolves the applied cycle time / headcount / cat-score for the product so users can see exactly what each downstream Run Sheet uses.
 * @summary List Run Sheets using this operation
 */
export const operationsControllerListBillsOfOperationsForOperation = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListBillsOfOperationsForOperationResponse> => {

  return customFetch<operationsControllerListBillsOfOperationsForOperationResponse>(getOperationsControllerListBillsOfOperationsForOperationUrl(operationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListBillsOfOperationsForOperationQueryKey = (operationId: string,) => {
    return [
    `/operations/${operationId}/bills-of-operations`
    ] as const;
    }


export const getOperationsControllerListBillsOfOperationsForOperationQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListBillsOfOperationsForOperationQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>> = ({ signal }) => operationsControllerListBillsOfOperationsForOperation(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListBillsOfOperationsForOperationQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>>
export type OperationsControllerListBillsOfOperationsForOperationQueryError = unknown


export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Run Sheets using this operation
 */

export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Run Sheets using this operation
 */
export const prefetchOperationsControllerListBillsOfOperationsForOperationQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListBillsOfOperationsForOperationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListBillsOfOperationsForOperationQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>> = ({ signal }) => operationsControllerListBillsOfOperationsForOperation(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListBillsOfOperationsForOperationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>>
export type OperationsControllerListBillsOfOperationsForOperationSuspenseQueryError = unknown


export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Run Sheets using this operation
 */

export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerListOperationReleaseTargetsResponse200 = {
  data: OperationReleaseTargetDto[]
  status: 200
}

export type operationsControllerListOperationReleaseTargetsResponse404 = {
  data: void
  status: 404
}

export type operationsControllerListOperationReleaseTargetsResponseSuccess = (operationsControllerListOperationReleaseTargetsResponse200) & {
  headers: Headers;
};
export type operationsControllerListOperationReleaseTargetsResponseError = (operationsControllerListOperationReleaseTargetsResponse404) & {
  headers: Headers;
};

export type operationsControllerListOperationReleaseTargetsResponse = (operationsControllerListOperationReleaseTargetsResponseSuccess | operationsControllerListOperationReleaseTargetsResponseError)

export const getOperationsControllerListOperationReleaseTargetsUrl = (operationId: string,) => {




  return `/operations/${operationId}/release-targets`
}

/**
 * Resolves the Run Sheets a release of this operation should update, given the operation's CURRENT staged relevance rules and overrides — including Run Sheets that would NEWLY gain the operation (a brand-new rule no released version reflects yet), plus Run Sheets that would lose or re-point it. Unlike GET :operation_id/bills-of-operations (which only reports Run Sheets whose released version already lists the operation), this is what the operation release wizard should enumerate so a zero-work-order "golden path" release still has targets. Each entry is a valid POST /change-control/runs/bill-of-operations-release target; currently_includes_operation=false with change=add is the newly-included case.
 * @summary List Run Sheets a release of this operation should target
 */
export const operationsControllerListOperationReleaseTargets = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListOperationReleaseTargetsResponse> => {

  return customFetch<operationsControllerListOperationReleaseTargetsResponse>(getOperationsControllerListOperationReleaseTargetsUrl(operationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListOperationReleaseTargetsQueryKey = (operationId: string,) => {
    return [
    `/operations/${operationId}/release-targets`
    ] as const;
    }


export const getOperationsControllerListOperationReleaseTargetsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationReleaseTargetsQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>> = ({ signal }) => operationsControllerListOperationReleaseTargets(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationReleaseTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>>
export type OperationsControllerListOperationReleaseTargetsQueryError = void


export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Run Sheets a release of this operation should target
 */

export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Run Sheets a release of this operation should target
 */
export const prefetchOperationsControllerListOperationReleaseTargetsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListOperationReleaseTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationReleaseTargetsQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>> = ({ signal }) => operationsControllerListOperationReleaseTargets(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListOperationReleaseTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>>
export type OperationsControllerListOperationReleaseTargetsSuspenseQueryError = void


export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Run Sheets a release of this operation should target
 */

export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerListRulesForOperationResponse200 = {
  data: RelevanceRuleDto[]
  status: 200
}

export type operationsControllerListRulesForOperationResponseSuccess = (operationsControllerListRulesForOperationResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListRulesForOperationResponse = (operationsControllerListRulesForOperationResponseSuccess)

export const getOperationsControllerListRulesForOperationUrl = (operationId: string,) => {




  return `/operations/${operationId}/rules`
}

/**
 * Returns every operation_relevance_rules row whose operation_id matches, across all products / containers. The operation detail page renders this list so users can see which container selections pull this operation onto products. Read-only here — write paths (POST/DELETE on /boo/rules) stay admin-gated.
 * @summary List relevance rules targeting this operation
 */
export const operationsControllerListRulesForOperation = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerListRulesForOperationResponse> => {

  return customFetch<operationsControllerListRulesForOperationResponse>(getOperationsControllerListRulesForOperationUrl(operationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerListRulesForOperationQueryKey = (operationId: string,) => {
    return [
    `/operations/${operationId}/rules`
    ] as const;
    }


export const getOperationsControllerListRulesForOperationQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListRulesForOperationQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>> = ({ signal }) => operationsControllerListRulesForOperation(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListRulesForOperationQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>>
export type OperationsControllerListRulesForOperationQueryError = unknown


export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List relevance rules targeting this operation
 */

export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListRulesForOperationQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List relevance rules targeting this operation
 */
export const prefetchOperationsControllerListRulesForOperationQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListRulesForOperationQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerListRulesForOperationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListRulesForOperationQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>> = ({ signal }) => operationsControllerListRulesForOperation(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerListRulesForOperationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>>
export type OperationsControllerListRulesForOperationSuspenseQueryError = unknown


export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List relevance rules targeting this operation
 */

export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerListRulesForOperationSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerGetOperationStationsResponse200 = {
  data: OperationStationDto[]
  status: 200
}

export type operationsControllerGetOperationStationsResponse404 = {
  data: void
  status: 404
}

export type operationsControllerGetOperationStationsResponseSuccess = (operationsControllerGetOperationStationsResponse200) & {
  headers: Headers;
};
export type operationsControllerGetOperationStationsResponseError = (operationsControllerGetOperationStationsResponse404) & {
  headers: Headers;
};

export type operationsControllerGetOperationStationsResponse = (operationsControllerGetOperationStationsResponseSuccess | operationsControllerGetOperationStationsResponseError)

export const getOperationsControllerGetOperationStationsUrl = (operationId: string,) => {




  return `/operations/${operationId}/stations`
}

/**
 * Returns every live (non-archived) station belonging to the operation's partner, each with an `is_enabled` flag indicating whether the operation is currently enabled on that station (an `operations_stations` row exists). Powers the "Operation Enabled On" step. Archived stations, zones, and factories are excluded.
 * @summary List the partner stations this operation can be enabled on
 */
export const operationsControllerGetOperationStations = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerGetOperationStationsResponse> => {

  return customFetch<operationsControllerGetOperationStationsResponse>(getOperationsControllerGetOperationStationsUrl(operationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOperationsControllerGetOperationStationsQueryKey = (operationId: string,) => {
    return [
    `/operations/${operationId}/stations`
    ] as const;
    }


export const getOperationsControllerGetOperationStationsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationStationsQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>> = ({ signal }) => operationsControllerGetOperationStations(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: operationId !== null && operationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetOperationStationsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>>
export type OperationsControllerGetOperationStationsQueryError = void


export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the partner stations this operation can be enabled on
 */

export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetOperationStationsQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List the partner stations this operation can be enabled on
 */
export const prefetchOperationsControllerGetOperationStationsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerGetOperationStationsQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getOperationsControllerGetOperationStationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationStationsQueryKey(operationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>> = ({ signal }) => operationsControllerGetOperationStations(operationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OperationsControllerGetOperationStationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>>
export type OperationsControllerGetOperationStationsSuspenseQueryError = void


export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the partner stations this operation can be enabled on
 */

export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOperationsControllerGetOperationStationsSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type operationsControllerSetOperationStationEnabledResponse200 = {
  data: OperationStationToggleResultDto
  status: 200
}

export type operationsControllerSetOperationStationEnabledResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSetOperationStationEnabledResponse404 = {
  data: void
  status: 404
}

export type operationsControllerSetOperationStationEnabledResponseSuccess = (operationsControllerSetOperationStationEnabledResponse200) & {
  headers: Headers;
};
export type operationsControllerSetOperationStationEnabledResponseError = (operationsControllerSetOperationStationEnabledResponse400 | operationsControllerSetOperationStationEnabledResponse404) & {
  headers: Headers;
};

export type operationsControllerSetOperationStationEnabledResponse = (operationsControllerSetOperationStationEnabledResponseSuccess | operationsControllerSetOperationStationEnabledResponseError)

export const getOperationsControllerSetOperationStationEnabledUrl = (operationId: string,) => {




  return `/operations/${operationId}/stations`
}

/**
 * Toggles one `operations_stations` row for the operation. Enabling inserts the row (idempotent); disabling deletes it. Each real change is recorded by the AuditService. This is a direct write — it does NOT go through Run Sheet change control.
 * @summary Enable or disable this operation on a single station
 */
export const operationsControllerSetOperationStationEnabled = async (operationId: string,
    operationStationToggleDto: OperationStationToggleDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerSetOperationStationEnabledResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerSetOperationStationEnabledResponse>(getOperationsControllerSetOperationStationEnabledUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationStationToggleDto)
  }
);}





export const getOperationsControllerSetOperationStationEnabledMutationKey = () => ['operationsControllerSetOperationStationEnabled'] as const;

export const getOperationsControllerSetOperationStationEnabledMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,OperationsControllerSetOperationStationEnabledMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,OperationsControllerSetOperationStationEnabledMutationVariables, TContext> => {

const mutationKey = getOperationsControllerSetOperationStationEnabledMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, OperationsControllerSetOperationStationEnabledMutationVariables> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSetOperationStationEnabled(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSetOperationStationEnabledMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>>
    export type OperationsControllerSetOperationStationEnabledMutationBody = OperationStationToggleDto
    export type OperationsControllerSetOperationStationEnabledMutationError = void
    export type OperationsControllerSetOperationStationEnabledMutationVariables = {operationId: string;data: OperationStationToggleDto}

    /**
 * @summary Enable or disable this operation on a single station
 */
export const useOperationsControllerSetOperationStationEnabled = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,OperationsControllerSetOperationStationEnabledMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>,
        TError,
        OperationsControllerSetOperationStationEnabledMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerSetOperationStationEnabledMutationOptions(options), queryClient);
    }
    export type operationsControllerSaveStationsDraftResponse200 = {
  data: OperationStationsDraftDto
  status: 200
}

export type operationsControllerSaveStationsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveStationsDraftResponse404 = {
  data: void
  status: 404
}

export type operationsControllerSaveStationsDraftResponseSuccess = (operationsControllerSaveStationsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveStationsDraftResponseError = (operationsControllerSaveStationsDraftResponse400 | operationsControllerSaveStationsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerSaveStationsDraftResponse = (operationsControllerSaveStationsDraftResponseSuccess | operationsControllerSaveStationsDraftResponseError)

export const getOperationsControllerSaveStationsDraftUrl = (operationId: string,) => {




  return `/operations/${operationId}/stations-draft`
}

/**
 * Persists pending station enablement toggles to `operations.draft_*` — the same reused ENG-764 draft slot the Checks-page draft uses (no separate columns were added). Only one kind of draft (Checks or Stations) can be pending at a time; saving one supersedes the other. Intended to be called on a short debounce from the Stations editor so in-progress toggles survive a refresh before the user commits. Committing (`POST /operations/:operation_id/stations-draft/commit`) applies the changes and clears the draft back to null.
 * @summary Autosave a Stations-page draft
 */
export const operationsControllerSaveStationsDraft = async (operationId: string,
    operationStationsDraftUpdateDto: OperationStationsDraftUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerSaveStationsDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerSaveStationsDraftResponse>(getOperationsControllerSaveStationsDraftUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationStationsDraftUpdateDto)
  }
);}





export const getOperationsControllerSaveStationsDraftMutationKey = () => ['operationsControllerSaveStationsDraft'] as const;

export const getOperationsControllerSaveStationsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,OperationsControllerSaveStationsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,OperationsControllerSaveStationsDraftMutationVariables, TContext> => {

const mutationKey = getOperationsControllerSaveStationsDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, OperationsControllerSaveStationsDraftMutationVariables> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveStationsDraft(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveStationsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>>
    export type OperationsControllerSaveStationsDraftMutationBody = OperationStationsDraftUpdateDto
    export type OperationsControllerSaveStationsDraftMutationError = void
    export type OperationsControllerSaveStationsDraftMutationVariables = {operationId: string;data: OperationStationsDraftUpdateDto}

    /**
 * @summary Autosave a Stations-page draft
 */
export const useOperationsControllerSaveStationsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,OperationsControllerSaveStationsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>,
        TError,
        OperationsControllerSaveStationsDraftMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerSaveStationsDraftMutationOptions(options), queryClient);
    }
    export type operationsControllerCommitStationsDraftResponse200 = {
  data: OperationStationsDraftCommitResultDto
  status: 200
}

export type operationsControllerCommitStationsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerCommitStationsDraftResponse404 = {
  data: void
  status: 404
}

export type operationsControllerCommitStationsDraftResponseSuccess = (operationsControllerCommitStationsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerCommitStationsDraftResponseError = (operationsControllerCommitStationsDraftResponse400 | operationsControllerCommitStationsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerCommitStationsDraftResponse = (operationsControllerCommitStationsDraftResponseSuccess | operationsControllerCommitStationsDraftResponseError)

export const getOperationsControllerCommitStationsDraftUrl = (operationId: string,) => {




  return `/operations/${operationId}/stations-draft/commit`
}

/**
 * Applies every staged station enablement/disablement from the pending draft (each real change recorded by the AuditService, same as a single live toggle) and clears the draft, all in one transaction. Like a single station toggle, this is a direct write that does NOT go through Run Sheet change control.
 * @summary Commit a pending Stations draft
 */
export const operationsControllerCommitStationsDraft = async (operationId: string, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerCommitStationsDraftResponse> => {

  return customFetch<operationsControllerCommitStationsDraftResponse>(getOperationsControllerCommitStationsDraftUrl(operationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOperationsControllerCommitStationsDraftMutationKey = () => ['operationsControllerCommitStationsDraft'] as const;

export const getOperationsControllerCommitStationsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,OperationsControllerCommitStationsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,OperationsControllerCommitStationsDraftMutationVariables, TContext> => {

const mutationKey = getOperationsControllerCommitStationsDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, OperationsControllerCommitStationsDraftMutationVariables> = (props) => {
          const {operationId} = props ?? {};

          return  operationsControllerCommitStationsDraft(operationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerCommitStationsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>>

    export type OperationsControllerCommitStationsDraftMutationError = void
    export type OperationsControllerCommitStationsDraftMutationVariables = {operationId: string}

    /**
 * @summary Commit a pending Stations draft
 */
export const useOperationsControllerCommitStationsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,OperationsControllerCommitStationsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>,
        TError,
        OperationsControllerCommitStationsDraftMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerCommitStationsDraftMutationOptions(options), queryClient);
    }
    export type operationsControllerSaveChecksDraftResponse200 = {
  data: OperationChecksDraftDto
  status: 200
}

export type operationsControllerSaveChecksDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveChecksDraftResponse404 = {
  data: void
  status: 404
}

export type operationsControllerSaveChecksDraftResponse409 = {
  data: void
  status: 409
}

export type operationsControllerSaveChecksDraftResponseSuccess = (operationsControllerSaveChecksDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveChecksDraftResponseError = (operationsControllerSaveChecksDraftResponse400 | operationsControllerSaveChecksDraftResponse404 | operationsControllerSaveChecksDraftResponse409) & {
  headers: Headers;
};

export type operationsControllerSaveChecksDraftResponse = (operationsControllerSaveChecksDraftResponseSuccess | operationsControllerSaveChecksDraftResponseError)

export const getOperationsControllerSaveChecksDraftUrl = (operationId: string,) => {




  return `/operations/${operationId}/checks-draft`
}

/**
 * ENG-764. Persists the pre-flight / in-process check arrays to `operations.draft_*` columns WITHOUT bumping the operation version or cascading to Bills of Operations — unlike `PATCH /operations/:operation_id`, this never touches `operation_versions` (which is immutable-once-written by design). Intended to be called on a short debounce from the Checks editor so in-progress edits survive a refresh before the user commits. A commit (`PATCH /operations/:operation_id`) clears the draft back to null.
 * @summary Autosave a Checks-page draft
 */
export const operationsControllerSaveChecksDraft = async (operationId: string,
    operationChecksDraftUpdateDto: OperationChecksDraftUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerSaveChecksDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerSaveChecksDraftResponse>(getOperationsControllerSaveChecksDraftUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationChecksDraftUpdateDto)
  }
);}





export const getOperationsControllerSaveChecksDraftMutationKey = () => ['operationsControllerSaveChecksDraft'] as const;

export const getOperationsControllerSaveChecksDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,OperationsControllerSaveChecksDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,OperationsControllerSaveChecksDraftMutationVariables, TContext> => {

const mutationKey = getOperationsControllerSaveChecksDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, OperationsControllerSaveChecksDraftMutationVariables> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveChecksDraft(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveChecksDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>>
    export type OperationsControllerSaveChecksDraftMutationBody = OperationChecksDraftUpdateDto
    export type OperationsControllerSaveChecksDraftMutationError = void
    export type OperationsControllerSaveChecksDraftMutationVariables = {operationId: string;data: OperationChecksDraftUpdateDto}

    /**
 * @summary Autosave a Checks-page draft
 */
export const useOperationsControllerSaveChecksDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,OperationsControllerSaveChecksDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>,
        TError,
        OperationsControllerSaveChecksDraftMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerSaveChecksDraftMutationOptions(options), queryClient);
    }
    export type operationsControllerSaveDetailsDraftResponse200 = {
  data: OperationDetailsDraftDto
  status: 200
}

export type operationsControllerSaveDetailsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveDetailsDraftResponse404 = {
  data: void
  status: 404
}

export type operationsControllerSaveDetailsDraftResponseSuccess = (operationsControllerSaveDetailsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveDetailsDraftResponseError = (operationsControllerSaveDetailsDraftResponse400 | operationsControllerSaveDetailsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerSaveDetailsDraftResponse = (operationsControllerSaveDetailsDraftResponseSuccess | operationsControllerSaveDetailsDraftResponseError)

export const getOperationsControllerSaveDetailsDraftUrl = (operationId: string,) => {




  return `/operations/${operationId}/details-draft`
}

/**
 * Persists pending Details-form field values (name, category, work time, headcount, per-category cycle time/headcount, is_final) to `operations.draft_*` — the same reused ENG-764 draft slot the Checks-page draft uses (no separate columns were added). Only one kind of draft (Checks, Stations, or Details) can be pending at a time; saving one supersedes whichever was pending before. Intended to be called on a short debounce from the Details form so in-progress edits survive a refresh before the user commits. There is no separate commit endpoint for this draft kind: committing sends this same shape straight to `PATCH /operations/:operation_id`, which already clears this draft slot unconditionally.
 * @summary Autosave a Details-page draft
 */
export const operationsControllerSaveDetailsDraft = async (operationId: string,
    operationDetailsDraftUpdateDto: OperationDetailsDraftUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerSaveDetailsDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerSaveDetailsDraftResponse>(getOperationsControllerSaveDetailsDraftUrl(operationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationDetailsDraftUpdateDto)
  }
);}





export const getOperationsControllerSaveDetailsDraftMutationKey = () => ['operationsControllerSaveDetailsDraft'] as const;

export const getOperationsControllerSaveDetailsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,OperationsControllerSaveDetailsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,OperationsControllerSaveDetailsDraftMutationVariables, TContext> => {

const mutationKey = getOperationsControllerSaveDetailsDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, OperationsControllerSaveDetailsDraftMutationVariables> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveDetailsDraft(operationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveDetailsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>>
    export type OperationsControllerSaveDetailsDraftMutationBody = OperationDetailsDraftUpdateDto
    export type OperationsControllerSaveDetailsDraftMutationError = void
    export type OperationsControllerSaveDetailsDraftMutationVariables = {operationId: string;data: OperationDetailsDraftUpdateDto}

    /**
 * @summary Autosave a Details-page draft
 */
export const useOperationsControllerSaveDetailsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,OperationsControllerSaveDetailsDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>,
        TError,
        OperationsControllerSaveDetailsDraftMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerSaveDetailsDraftMutationOptions(options), queryClient);
    }
    export type operationsControllerBulkUpdateResponse201 = {
  data: void
  status: 201
}

export type operationsControllerBulkUpdateResponseSuccess = (operationsControllerBulkUpdateResponse201) & {
  headers: Headers;
};
;

export type operationsControllerBulkUpdateResponse = (operationsControllerBulkUpdateResponseSuccess)

export const getOperationsControllerBulkUpdateUrl = () => {




  return `/operations/bulk-update`
}

export const operationsControllerBulkUpdate = async (operationBulkUpdateDto: OperationBulkUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<operationsControllerBulkUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<operationsControllerBulkUpdateResponse>(getOperationsControllerBulkUpdateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(operationBulkUpdateDto)
  }
);}





export const getOperationsControllerBulkUpdateMutationKey = () => ['operationsControllerBulkUpdate'] as const;

export const getOperationsControllerBulkUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,OperationsControllerBulkUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,OperationsControllerBulkUpdateMutationVariables, TContext> => {

const mutationKey = getOperationsControllerBulkUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, OperationsControllerBulkUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerBulkUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerBulkUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>>
    export type OperationsControllerBulkUpdateMutationBody = OperationBulkUpdateDto
    export type OperationsControllerBulkUpdateMutationError = unknown
    export type OperationsControllerBulkUpdateMutationVariables = {data: OperationBulkUpdateDto}

    export const useOperationsControllerBulkUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,OperationsControllerBulkUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerBulkUpdate>>,
        TError,
        OperationsControllerBulkUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOperationsControllerBulkUpdateMutationOptions(options), queryClient);
    }
